<template>
  <div class="excelExport-list">
    <Row>
        <Col :xs="24" :sm="12">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                    <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
                </FormItem> 
                <FormItem>
                    <DatePicker type="datetimerange" format="yyyy-MM-dd" :value="[formItem.starttime,formItem.endtime]" @on-change="changeDate" style="width: 200px" placeholder="开始时间 - 结束时间"></DatePicker>
                </FormItem> 
                <FormItem>
                    <Button type="primary" @click="renderTable('formItem')">查找</Button>
                </FormItem>
            </Form>
        </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
     <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'excelExport-list',
    data () {
        return {
            loading: true,
            dataloading: true,
            thumblist: [],
            pages:{
                page:1,
                size:10,
                total:0
            },
            title:'',
            formItem:{
                'key':'',
            },
            bigDisplay:'',
            list: [
                {
                    title: 'Id',
                    key: 'id',
                    fixed: 'left',
                    width:90
                },
                {
                    title: '类型',
                    key: 'type',
                    width:80,
                    render: (h, params) => {
                        var par = params.row.type == 1 ? '导出' : '导入';
                        return h('div', [
                            h('span', {
                            }, par)
                        ]);
                    }
                },
                {
                    title: '文件名称',
                    key: 'file_name',
                    minWidth:200
                },
                {
                    title: '状态',
                    key: 'status',
                    minWidth:200,
                    render: (h, params) => {
                        var par = params.row.status == 0 ? '未开始' : (params.row.status == 1 ?'进行中':(params.row.status == 2 )?'已完成':'失败');
                        return h('div', [
                            h('span', {
                            }, par)
                        ]);
                    }
                },
                {
                    title: '描述',
                    key: 'desb',
                    minWidth:200
                },
                {
                    title: '开始时间',
                    key: 'created_at',
                    width:150
                },
                {
                    title: '结束时间',
                    key: 'end_at',
                    width:150
                },
                {
                    title: '操作',
                    key: 'action',
                    width:80,
                    align: 'center',
                    fixed: 'right',
                    render: (h, params) => {
                        var s = params.row.status==2?'block':'none';
                        return h('div', [
                            h('Button', {
                                style:{
                                    marginRight:'8px',
                                    display:s
                                },
                                props: {
                                    type: 'success',
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        window.location.href = params.row.addr;
                                    }
                                }
                            }, '下载')
                        ]);
                    }
                }
            ],
            tablelist: [],
            excelExport:{
                name:'',
                status:true,
            },
            showModalStatus:false,
            excelExportValidate: {
                name: [
                    { required: true, message: '名称必须填写', trigger: 'blur' }
                ],
            },
        }
    },
    created: function () {
        // 取数据
        this.getTableList();
    },
    methods:{
        getTableList:function(){
          this.$api.excelExport.list({"page":this.pages.page,"size":this.pages.size}).then(res=>{
            this.dataloading = false;
            if(res.code == 200)
            {
                this.tablelist = res.result.list;
                this.pages.total = res.result.total;
                this.$Message.success(res.msg);
            }
          });
          return;
        },
         // 翻页
        changePage() {
            this.pages.page = this.$refs['listPage'].currentPage;
            this.renderTable(1);
        },
        changeDate(val) {
            this.formItem.starttime = val[0];
            this.formItem.endtime = val[1];
        },
        // 筛选
        renderTable:function(name) {
            if (name !=1){
                this.pages.page = 1;
             }
            this.dataloading = true;
            var ps = {
                'key':this.formItem.key,
                "page":this.pages.page,
                "size":this.pages.size,
                start_date :this.formItem.starttime,    //   否   date    开始时间
                end_date : this.formItem.endtime,

            };
            this.$api.excelExport.list(ps).then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.tablelist = res.result.list;
                    this.pages.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
            return;
        }
    },
}
</script>
